import { render, staticRenderFns } from "./SettingTextInput.vue?vue&type=template&id=d0885c46&scoped=true&"
import script from "./SettingTextInput.vue?vue&type=script&lang=js&"
export * from "./SettingTextInput.vue?vue&type=script&lang=js&"
import style0 from "./SettingTextInput.vue?vue&type=style&index=0&id=d0885c46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0885c46",
  null
  
)

export default component.exports